var map = {
	"./attiva-piu.png": 69879,
	"./benesse.png": 27443,
	"./confirmea.jpg": 44837,
	"./cryptosmart.jpg": 12900,
	"./fondoSanMarco.jpg": 26755,
	"./grupoG8.jpg": 89975,
	"./jimmyk.png": 828,
	"./ods.png": 28722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4742;